import React from 'react';

const Hero1 = ({ imagen, titulo, descripcion, botonTexto }) => (
  <section className="flex flex-col lg:flex-row w-full bg-white">
    <div className="bg-[#1746a2] text-white w-full lg:w-2/5 px-6 sm:px-10 lg:px-12 py-10 lg:py-0 flex items-center justify-center">
      <div className="max-w-xl">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 mt-2 lg:mt-20">
          {titulo}
        </h1>
        <p className="text-base sm:text-lg lg:text-2xl font-semibold text-[#E8F2F4] mb-8 lg:mb-20">
          {descripcion}
        </p>
        {botonTexto && (
          <button className="w-full bg-[#276AE8] text-white font-bold py-3 rounded-full shadow-md hover:bg-[#3689ff] transition text-sm md:text-base">
            {botonTexto}
          </button>
        )}
      </div>
    </div>
    <div
      className="w-full lg:w-3/5 h-64 sm:h-80 lg:h-auto min-h-[240px] lg:min-h-[60vh] bg-cover bg-center"
      style={{ backgroundImage: `url(${imagen})` }}
      role="img"
      aria-label={titulo}
    />
  </section>
);

export default Hero1;
